export type FormInput = Record<string, any>;

export function convertFormDataToInput(data: FormData): FormInput {
  const obj = Object.fromEntries(data);

  for (const [key, value] of Object.entries(obj)) {
    if (value === "on") {
      obj[key] = "true";
    } else if (value === "off") {
      obj[key] = "false";
    }
  }

  return obj;
}
